export const SQFT_IN_ACRE = 43560

export const STATE_ABBREVIATIONS = {
  AL: 'Alabama',
  AK: 'Alaska',
  AS: 'American Samoa',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District of Columbia',
  FM: 'Micronesia',
  FL: 'Florida',
  GA: 'Georgia',
  GU: 'Guam',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MH: 'Marshall Islands',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PW: 'Palau',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VI: 'Virgin Islands',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
}

export const DAYS_OF_WEEK = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
] as const
export type DayOfWeek = (typeof DAYS_OF_WEEK)[number]

/** The different windows, in days, we create guest card conversion metrics for */
export const GUESTCARD_CONVERSION_WINDOWS = [1, 7, 14, 30, 60]

/**
 * Cap historical weather backfills at 4 years, to prevent a large look-back window multiplied by
 * many properties from ballooning into a huge number of paid OpenWeather day-summary calls. The
 * `fetchWeatherData` job clamps to this regardless of what a caller (e.g. the admin UI) sends.
 */
export const MAX_HISTORICAL_WEATHER_BACKFILL_DAYS = 365 * 4

/** Default bedroom count used when normalizing prices by bedroom.
 * Used as fallback for studio apartments or units with missing/invalid bedroom data. */
export const DEFAULT_BEDROOM_COUNT_FOR_NORMALIZATION = 1

// WARNING: These values are in the db (AttributeMappingModelType.normalizedValue), so if you want to
// remove one, you need to migrate the db first.
export enum ChargeCodeNormalizedValue {
  RENT = 'rent',
  RENT_AMENITIES = 'rentAmenities',
  CONCESSION = 'concession',
  CONCESSION_RENEWAL = 'concessionRenewal',
  RENTABLE = 'rentable',
}
// WARNING: These values are in the db (AttributeMappingModelType.normalizedValue), so if you want to
// remove one, you need to migrate the db first.
export enum GuestcardEventResultNormalizedValue {
  CANCELLED = 'cancelled',
  COMPLETED = 'completed',
  MISSED = 'missed',
  RESCHEDULED = 'rescheduled',
}

export const SCOTT_AIR_SID = 'p932q4zzjfjt'

/**
 * Identity details for the Rentana system user, used when actions are performed automatically by
 * the system
 */
export const RENTANA_SYSTEM_USER_IDENTITY = {
  sid: 'rentana_system_user',
  fullName: 'Rentana',
  avatarSid: 'rentana_system_user',
} as const
